
export const Theme = {
  helperText: [
    'text-xs text-gray-400 mt-2',
    'dark:text-gray-500'
  ],
  helperTextError: [
    'text-danger-500',
    'dark:text-danger-500'
  ]
}
